export default {
    clientCount: '取引先数',
    createGroup: 'グループを作成',
    createRole: '役割を作成',
    groupName: 'グループ名',
    groups: 'グループ',
    memberCount: 'メンバー数',
    noGroups: 'まだグループを作成されていません。',
    noRoles:
        'まだグループは作成されていません。グループを作成して、ドキュメントやクライアントの可視性を制御してください。',
    roleName: '役割名',
    roles: '役割',
    subtitleGroups:
        '取引先に担当グループを設定すると、取引先や関連書類、レポートが所属メンバーにのみ表示されます。',

    subtitleRole: '各メンバーに役割を割り当てることができます。',
};
